import React from 'react'
import { isMobile } from 'react-device-detect'

import { AppMode } from './AppMode'
import { Speakers } from './Speakers'

export const AppHeader = () => (
    <div className="app__header d-flex justify-content-between align-items-center">
        <AppMode />
        {!isMobile && <Speakers />}
    </div>
)
